module.exports = "/packs/images/logo~8a7917fbeb9cc6057bf755b8b6505d45.svg";